export enum MaintenanceRequestStatus {
  Outstanding = 0,
  ConvertedToWorkOrder = 1,
  Rejected = 2,
}
